import type { Rng } from "@obean/game-contract";

/**
 * The platform RNG: mulberry32 (32-bit state, fast, good enough for games). Deterministic for a seed;
 * `state()`/`restore()` let the position travel inside snapshots so a resumed match continues exactly.
 */
export function createRng(seed: number): Rng {
  let s = seed >>> 0;
  const next = (): number => {
    s = (s + 0x6d2b79f5) >>> 0;
    let t = s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  return {
    next,
    int: (maxExclusive) => Math.floor(next() * maxExclusive),
    state: () => s,
    restore: (state) => {
      s = state >>> 0;
    },
  };
}
